export const normalizeCleaningEffectivenessFlags = (flags) => {
  if (!flags) return [];

  const inputFlags = Array.isArray(flags)
    ? flags
    : typeof flags === "string"
      ? flags.split("")
      : [];

  const normalized = inputFlags
    .map((flag) => String(flag).toUpperCase())
    .filter((flag) => flag === "W" || flag === "R" || flag === "E")
    .sort();

  return Array.from(new Set(normalized));
};

export const createCleaningEffectivenessCell = (value, flags = []) => ({
  value,
  flags: normalizeCleaningEffectivenessFlags(flags),
});

export const parseCleaningEffectivenessValue = (input) => {
  if (input && typeof input === "object" && "value" in input) {
    const numericValue = parseFloat(input.value);
    return {
      value: input.value,
      numericValue: Number.isNaN(numericValue) ? NaN : numericValue,
      flags: normalizeCleaningEffectivenessFlags(input.flags),
    };
  }

  if (input === null || input === undefined) {
    return { value: input, numericValue: NaN, flags: [] };
  }

  const raw = String(input).trim();
  const match = raw.match(/^(-?[\d.]*)\s*([WRE]*)$/);
  const numericPart = (match?.[1] ?? raw).trim();
  const numericValue = parseFloat(numericPart);

  return {
    value: input,
    numericValue: Number.isNaN(numericValue) ? NaN : numericValue,
    flags: normalizeCleaningEffectivenessFlags(match?.[2] ?? []),
  };
};

export const getCleaningEffectivenessNumeric = (input) =>
  parseCleaningEffectivenessValue(input).numericValue;

export const getCleaningEffectivenessFlags = (input) =>
  parseCleaningEffectivenessValue(input).flags;

export const getCleaningEffectivenessFlagSuffix = (input) =>
  getCleaningEffectivenessFlags(input).join("");

export const formatCleaningEffectivenessValue = (input) => {
  const FLAG_DISPLAY_ORDER = {
    R: 0,
    W: 1,
    E: 2,
  };

  const formatFlagCodes = (flags = []) =>
    flags
      .slice()
      .sort(
        (a, b) =>
          (FLAG_DISPLAY_ORDER[a] ?? Number.MAX_SAFE_INTEGER) -
          (FLAG_DISPLAY_ORDER[b] ?? Number.MAX_SAFE_INTEGER),
      )
      .join(", ");

  const { numericValue, flags } = parseCleaningEffectivenessValue(input);
  const flagSuffix = formatFlagCodes(flags);
  const displayFlag = flagSuffix ? ` ${flagSuffix}` : "";

  if (Number.isNaN(numericValue)) {
    return flagSuffix || "*";
  }

  if (numericValue === -1) {
    return flagSuffix || "-";
  }

  if (numericValue < 0) {
    return `< 0${displayFlag}`;
  }

  if (numericValue > 100) {
    return `> 100${displayFlag}`;
  }

  return `${(Math.floor(numericValue * 10) / 10).toFixed(1)}${displayFlag}`;
};